<template>
  <v-row>
    <v-col cols="12" :md="12" v-if="trackingDetails.events !== undefined">
      <div color="primary" dark flat>
        <div class="tracking text-h6 py-0 my-0">
          Tracking #{{ trackingDetails.tracking_no }}
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-bind="attrs"
                v-on="on"
                small
                @click="download(trackingDetails.tracking_no)"
                v-if="trackingDetails.events.order.status == 'Post'"
              >
                mdi-download
              </v-icon>
            </template>
            <span>Download Label</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-bind="attrs"
                v-on="on"
                small
                @click="downloadSingleInvoice(trackingDetails.tracking_no)"
                v-if="
                  trackingDetails.events.order.download_invoice == 'yes' &&
                  checkPermission(
                    'app_consignment_order:download_shipping_invoice'
                  )
                "
              >
                mdi-receipt
              </v-icon>
            </template>
            <span>Download Invoice</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-bind="attrs"
                v-on="on"
                small
                @click="run(trackingDetails)"
                v-if="
                  checkPermission('app_client:run_summary_temp') &&
                  trackingDetails.events.order.status !== 'Exception' &&
                  $store.getters.user.user_category == 3
                "
              >
                mdi-reload
              </v-icon>
            </template>
            <span>Run Temp Cron</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-bind="attrs"
                v-on="on"
                small
                @click="retrigger(trackingDetails)"
                v-if="
                  checkPermission('app_sla_tracker:sla_manual_trigger') &&
                  trackingDetails.events.order.status == 'Post' &&
                  $store.getters.user.user_category == 3
                "
              >
                mdi-arrange-bring-forward
              </v-icon>
            </template>
            <span>Retrigger Sla</span>
          </v-tooltip>
          <span
            v-if="trackingDetails.events.order.status == 'Exception'"
            class="error--text ml-2"
            style="position: relative"
          >
            <template>
              <template>
                <span
                  class="mb-4 mr-2"
                  v-if="trackingDetails.events.order.status == 'Exception'"
                  style="cursor: pointer"
                >
                  <v-btn
                    small
                    color="error"
                    class="mb-2"
                    @click="dialogMessage = true"
                    >Error</v-btn
                  >
                </span>
              </template>

              <v-dialog v-model="dialogMessage" width="600px">
                <v-card class="mx-auto p-6">
                  <v-card-title>Error message</v-card-title>
                  <v-divider></v-divider>

                  <v-card-text class="">
                    <div class="title">
                      <div class="text-caption">
                        <b
                          >{{ trackingDetails.events.order.order_reference }}
                          -
                        </b>
                        {{
                          trackingDetails.events.order.error[0]["message"] +
                          " - " +
                          trackingDetails.events.order.error[0]["error"]
                        }}
                      </div>
                    </div>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" @click="dialogMessage = false"
                      >Close</v-btn
                    >
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </template>
          </span>
          <span class="d-block" style="float: right">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="primary"
                  class="mb-2 ml-2"
                  v-bind="attrs"
                  small
                  v-on="on"
                  :loading="syncLoader"
                  v-if="
                    checkPermission('app_client:fetch_events_from_carrier') &&
                    $store.getters.user.user_category == 3 &&
                    trackingDetails.events.order.carrier_code
                  "
                  @click="syncData(item)"
                >
                  <v-icon>mdi-sync</v-icon>
                </v-btn>
              </template>

              <span>Sync</span>
            </v-tooltip>

            <span
              v-if="
                trackingDetails.events.order.date_time_last_sync &&
                userCategory.user_category == 3
              "
              class="ml-2"
            >
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <span medium class="mr-2" v-on="on">
                    {{
                      trackingDetails.events.order.date_time_last_sync
                        | uaeDateTime
                        | localMomentNew("DD MMM, YYYY hh:mm A")
                    }}
                  </span>
                </template>
                <span>Recent data Synced at</span>
              </v-tooltip>
            </span>
          </span>

          <span class="d-block" style="float: right">
            {{ trackingDetails.events.order.carrier_name }}
            {{ trackingDetails.events.order.carrier_tracking_name }}
            <v-btn
              small
              color="primary"
              class="mb-2"
              @click="showRowData()"
              v-if="
                checkPermission(
                  'app_events_tracking:tracking_event_response'
                ) && userCategory.user_category === 3
              "
              >Carrier Details</v-btn
            ></span
          >
        </div>

        <v-divider class="mb-4"></v-divider>
      </div>
      <v-card :loading="loader" class="elevations">
        <v-card-text dense>
          <v-row v-if="trackingDetails.events !== undefined">
            <v-col cols="12" md="3">
              <p class="py-0 my-0">From:</p>
              <font style="font-weight: 600">{{
                trackingDetails.events.order.client_name
              }}</font>
              <p class="py-0 my-0">Shipment Date:</p>
              <p
                class="py-0 my-0"
                v-if="trackingDetails.events.order.order_date"
              >
                {{
                  trackingDetails.events.order.order_date
                    | moment("DD MMM, YYYY hh:mm A")
                }}
              </p>
              <v-divider></v-divider>
              <p
                class="py-0 my-0"
                v-if="trackingDetails.events.order.consignor_name"
              >
                {{ trackingDetails.events.order.consignor_name }}
              </p>
              <p
                class="py-0 my-0"
                v-if="trackingDetails.events.order.consignor_email"
              >
                {{ trackingDetails.events.order.consignor_email }}
              </p>
              <p
                class="py-0 my-0"
                v-if="trackingDetails.events.order.consignor_phone"
              >
                {{ trackingDetails.events.order.consignor_phone }}
              </p>
              <p
                class="py-0 my-0"
                v-if="trackingDetails.events.order.consignor_address_line1"
              >
                {{ trackingDetails.events.order.consignor_address_line1 }}
              </p>
              <p
                class="py-0 my-0"
                v-if="trackingDetails.events.order.consignor_address_line2"
              >
                {{ trackingDetails.events.order.consignor_address_line2 }}
              </p>
              <p
                class="py-0 my-0"
                v-if="trackingDetails.events.order.consignor_address_area"
              >
                {{ trackingDetails.events.order.consignor_address_area }}
              </p>
              <p
                class="py-0 my-0"
                v-if="trackingDetails.events.order.consignor_street_address"
              >
                {{ trackingDetails.events.order.consignor_street_address }}
              </p>
              <p
                class="py-0 my-0"
                v-if="trackingDetails.events.order.consignor_building_name"
              >
                {{ trackingDetails.events.order.consignor_building_name }}
              </p>
              <p
                class="py-0 my-0"
                v-if="trackingDetails.events.order.origin_city"
              >
                <span v-if="trackingDetails.events.order.consignor_address_area"
                  >{{
                    trackingDetails.events.order.consignor_address_area
                  }},</span
                >
                {{ trackingDetails.events.order.origin_city }},
                {{ trackingDetails.events.order.origin_country }}
                <span v-if="trackingDetails.events.order.consignor_zip_code"
                  >,{{ trackingDetails.events.order.consignor_zip_code }}</span
                >
              </p>
            </v-col>
            <v-col cols="12" md="6" class="text-center">
              <div>
                <v-icon
                  class="v-application"
                  :class="{
                    'blue--text':
                      trackingDetails.events.order.order_status ===
                      'In-transit',
                    'green--text':
                      trackingDetails.events.order.order_status !==
                        'In-transit' &&
                      trackingDetails.events.order.order_status !== 'Done',
                    'orange--text':
                      trackingDetails.events.order.order_status === 'Done',
                  }"
                  style="font-size: 50px !important"
                  >mdi-truck-cargo-container</v-icon
                >
              </div>
              {{ trackingDetails.events.order.order_status }}<br />
              <span
                v-if="trackingDetails.events.order.order_status == 'Delivered'"
                >{{
                  trackingDetails.events.order.order_status_date
                    | moment("DD MMM, YYYY hh:mm A")
                }}

                {{
                  trackingDetails.events.event_history[0].country_timezone
                }}</span
              >
              <!-- <div class="mx-auto arrow-steps clearfix">
                <div
                  class="step"
                  v-for="(item, i) of trackingDetails.current_status.states"
                  :key="i"
                  :class="{ current: item.selected }"
                ></div>
              </div> -->
              <p
                class="py-0 my-0"
                v-if="trackingDetails.events.order.delivery_type"
              >
                <b>Delivery Type:</b>
                {{
                  capitalizeFirstLetter(
                    trackingDetails.events.order.delivery_type
                  )
                }}
              </p>
              <p
                class="py-0 my-0"
                v-if="trackingDetails.events.order.duty_handling"
              >
                <b>Duty Handling:</b>
                {{ trackingDetails.events.order.duty_handling.toUpperCase() }}
              </p>
              <p
                class="py-0 my-0"
                v-if="trackingDetails.events.order.service_type"
              >
                <b>Service Type:</b>
                {{ trackingDetails.events.order.service_name }}-({{
                  trackingDetails.events.order.service_type
                }}
                )
              </p>
            </v-col>
            <v-col cols="12" md="3">
              <p class="py-0 my-0">To:</p>
              <font style="font-weight: 600">
                {{ trackingDetails.events.order.customer_name }}</font
              >
              <p
                class="py-0 my-0"
                v-if="trackingDetails.events.order.order_status == 'Delivered'"
              >
                Delivery Date:
                {{
                  trackingDetails.events.order.order_status_date
                    | moment("DD MMM, YYYY hh:mm A")
                }}
              </p>
              <p class="py-0 my-0" v-if="trackingDetails.shipment_destination">
                {{
                  trackingDetails.shipment_destination.date
                    | moment("DD MMM, YYYY hh:mm A")
                }}
              </p>
              <v-divider></v-divider>
              <p class="py-0 my-0" v-if="trackingDetails.events.order">
                {{ trackingDetails.events.order.consignee_company_name }}
              </p>
              <p class="py-0 my-0" v-if="trackingDetails.events.order">
                {{ trackingDetails.events.order.location }}
              </p>
              <p class="py-0 my-0" v-if="trackingDetails.events.order">
                {{ trackingDetails.events.order.consignee_email }}
              </p>
              <p class="py-0 my-0" v-if="trackingDetails.events.order">
                {{ trackingDetails.events.order.consignee_phone }}
              </p>
              <p class="py-0 my-0" v-if="trackingDetails.events.order">
                {{ trackingDetails.events.order.consignee_address_line1 }}
              </p>
              <p class="py-0 my-0" v-if="trackingDetails.events.order">
                {{ trackingDetails.events.order.consignee_address_line2 }}
              </p>
              <p class="py-0 my-0" v-if="trackingDetails.events.order">
                {{ trackingDetails.events.order.consignee_address_area }}
              </p>
              <p class="py-0 my-0" v-if="trackingDetails.events.order">
                {{ trackingDetails.events.order.consignee_building_name }}
              </p>

              <p class="py-0 my-0" v-if="trackingDetails.events.order">
                {{ trackingDetails.events.order.consignee_street_address }}
              </p>
              <p class="py-0 my-0" v-if="trackingDetails.events.order">
                {{ trackingDetails.events.order.consignee_building_name }}
              </p>
              <p class="py-0 my-0" v-if="trackingDetails.events.order">
                <span v-if="trackingDetails.events.order.consignee_address_area"
                  >{{
                    trackingDetails.events.order.consignee_address_area
                  }},</span
                >
                {{ trackingDetails.events.order.destination_city }}
                {{ trackingDetails.events.order.destination_country }}
                <span v-if="trackingDetails.events.order.consignee_zip_code"
                  >, {{ trackingDetails.events.order.consignee_zip_code }}
                </span>
              </p>
              <v-divider
                v-if="trackingDetails.events.pudo_data.address"
              ></v-divider>
              <font
                style="font-weight: 600"
                v-if="trackingDetails.events.pudo_data.address"
                >Drop Location:
              </font>
              <p class="py-0 my-0" v-if="trackingDetails.events.pudo_data">
                <span v-if="trackingDetails.events.pudo_data.address"
                  >{{ trackingDetails.events.pudo_data.address }},</span
                >
                {{ trackingDetails.events.pudo_data.city_name }}
                {{ trackingDetails.events.pudo_data.country_name }}
                <span v-if="trackingDetails.events.pudo_data.postcode"
                  >, {{ trackingDetails.events.pudo_data.postcode }}
                </span>
              </p>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
    <v-col cols="12" md="3" v-if="selectedTrackNo.length > 1">
      <v-card :loading="loader" class="mx-auto fill-height">
        <v-virtual-scroll
          :bench="benched"
          :items="selectedTrackNo"
          height="200"
          item-height="40"
        >
          <template v-slot:default="{ item }">
            <v-list-item :key="item" @click="fetchDetails(item)">
              <v-list-item-content>
                <v-list-item-title>
                  <strong>{{ item }}</strong>
                </v-list-item-title>
              </v-list-item-content>

              <v-list-item-action>
                <v-icon small> mdi-open-in-new </v-icon>
              </v-list-item-action>
            </v-list-item>

            <v-divider></v-divider>
          </template>
        </v-virtual-scroll>
      </v-card>
    </v-col>
    <v-col cols="12" md="12" v-if="trackingDetails.events">
      <p class="text-h6 py-0 my-0">Shipments Details</p>
      <v-divider class="mb-4"></v-divider>
      <v-card :loading="loader" class="text-center" tile outlined>
        <template>
          <v-row no-gutters>
            <v-col cols="3">
              <v-card lass="card" class="elevations br-0" height="70">
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title class="body-1 pt-2"
                      >Payment Mode</v-list-item-title
                    >
                    <v-list-item-subtitle
                      v-if="trackingDetails.events.order.payment_mode == 'COD'"
                      >Cash (Cash amount
                      {{ trackingDetails.events.order.cod_value }}
                      {{ trackingDetails.events.order.cod_currency }})
                    </v-list-item-subtitle>
                    <v-list-item-subtitle v-else>{{
                      trackingDetails.events.order.payment_mode
                    }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-card>
            </v-col>
            <v-col cols="3">
              <v-card height="70" class="elevations br-0">
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title class="body-1 pt-2"
                      >Total Weight (In Kg)</v-list-item-title
                    >
                    <v-list-item-subtitle
                      >{{ trackingDetails.events.total_weight }}
                      {{
                        trackingDetails.events.order.total_weight
                      }}</v-list-item-subtitle
                    >
                  </v-list-item-content>
                </v-list-item>
              </v-card>
            </v-col>
            <v-col cols="3">
              <v-card height="70" class="elevations br-0">
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title class="body-1 pt-2"
                      >Total Pieces</v-list-item-title
                    >
                    <v-list-item-subtitle>{{
                      trackingDetails.events.order.total_pieces
                    }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-card>
            </v-col>
            <v-col cols="3">
              <v-card height="70" class="elevations br-0">
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title class="body-1 pt-2"
                      >Order Value</v-list-item-title
                    >
                    <v-list-item-subtitle
                      >{{ trackingDetails.events.order.order_value }}
                      {{
                        trackingDetails.events.order.order_currency_code
                      }}</v-list-item-subtitle
                    >
                  </v-list-item-content>
                </v-list-item>
              </v-card>
            </v-col>
          </v-row>
        </template>
      </v-card>
    </v-col>
    <v-col cols="12" md="12" v-if="trackingDetails.events.order.mawb">
      <p class="text-h6 py-0 my-0">PreAlert Details</p>
      <v-divider class="mb-4"></v-divider>
      <v-card :loading="loader" class="text-center" tile outlined>
        <template>
          <v-row no-gutters class="prealert">
            <v-col cols="2">
              <v-card lass="card" class="elevations br-0" height="90">
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title class="body-1 pt-2"
                      >MAWB</v-list-item-title
                    >
                    <v-list-item-subtitle>
                      {{ trackingDetails.events.order.mawb }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-card>
            </v-col>
            <v-col cols="2">
              <v-card lass="card" class="elevations br-0" height="90">
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title class="body-1 pt-2"
                      >Flight No</v-list-item-title
                    >
                    <v-list-item-subtitle>
                      {{ trackingDetails.events.order.flight_no }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-card>
            </v-col>
            <v-col cols="2">
              <v-card height="90" class="elevations br-0">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title class="body-1 pt-2">
                          Origin Airport
                        </v-list-item-title>
                        <v-list-item-subtitle v-bind="attrs" v-on="on">
                          {{ trackingDetails.events.order.origin_airport }}
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                  <span>{{ trackingDetails.events.order.origin_airport }}</span>
                </v-tooltip>
              </v-card>
            </v-col>
            <v-col cols="2">
              <v-card height="90" class="elevations br-0">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title class="body-1 pt-2">
                          Destination Airport
                        </v-list-item-title>
                        <v-list-item-subtitle v-bind="attrs" v-on="on">
                          {{ trackingDetails.events.order.destination_airport }}
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                  <span>{{
                    trackingDetails.events.order.destination_airport
                  }}</span>
                </v-tooltip>
              </v-card>
            </v-col>
            <v-col cols="2">
              <v-card height="90" class="elevations br-0">
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title class="body-1 pt-2"
                      >Arrival Date
                    </v-list-item-title>
                    <v-list-item-subtitle
                      v-if="trackingDetails.events.order.arrival_date"
                    >
                      {{
                        trackingDetails.events.order.arrival_date
                          | moment("DD MMM, YYYY")
                      }}</v-list-item-subtitle
                    >
                  </v-list-item-content>
                </v-list-item>
              </v-card>
            </v-col>
            <v-col cols="2">
              <v-card height="90" class="elevations br-0">
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title class="body-1 pt-2"
                      >Departure Date
                    </v-list-item-title>
                    <v-list-item-subtitle
                      v-if="trackingDetails.events.order.departure_date"
                    >
                      {{
                        trackingDetails.events.order.departure_date
                          | moment("DD MMM, YYYY")
                      }}</v-list-item-subtitle
                    >
                  </v-list-item-content>
                </v-list-item>
              </v-card>
            </v-col>
            <v-col cols="2">
              <v-card height="90" class="elevations br-0">
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title class="body-1 pt-2"
                      >Actual Arrival Date
                    </v-list-item-title>
                    <v-list-item-subtitle
                      v-if="trackingDetails.events.order.actual_arrival_date"
                    >
                      {{
                        trackingDetails.events.order.actual_arrival_date
                          | moment("DD MMM, YYYY hh:mm A")
                      }}<br />
                      {{
                        trackingDetails.events.order
                          .actual_arrival_date_timezone
                      }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-card>
            </v-col>
          </v-row>
        </template>
      </v-card>
    </v-col>
    <v-col cols="12" md="7" v-if="trackingDetails.events !== undefined">
      <p class="text-h6 py-0 my-0">Package Details</p>
      <v-divider class="mb-4"></v-divider>
      <template>
        <v-card
          :loading="loader"
          class="fill-height"
          tile
          outlined
          height="auto"
        >
          <div
            v-for="(group, index) in trackingDetails.events.package"
            :key="index"
            class="px-2 py-2"
          >
            <span class="px-2 pt-4 d-block"
              >Package: {{ group.package.package_name }} | Package Type:
              {{ group.package.package_type }} | Dimension (in cms):
              {{ group.package.height }} x {{ group.package.width }} x
              {{ group.package.length }} | Weight (In Kg)
              {{ group.package.weight }}</span
            >
            <table>
              <thead>
                <tr>
                  <th>Item Description</th>
                  <th>HS Code</th>
                  <th>Quantity</th>
                  <th>Weight (In Kg)</th>
                  <th>Value Per Unit</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in group.items" :key="item">
                  <td>
                    {{ item.description }}<span v-if="item.sku">,</span
                    >{{ item.sku }}
                  </td>
                  <td>{{ item.hs_code }}</td>
                  <td>{{ item.quantity }}</td>
                  <td>{{ item.weight }}</td>
                  <td>{{ item.value_per_unit }} {{ item.currency_code }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </v-card>
      </template>
    </v-col>
    <v-col cols="12" md="5" v-if="trackingDetails.events !== undefined">
      <p class="text-h6 my-0">Travel history</p>
      <v-divider class="mb-4"></v-divider>
      <v-card
        :loading="loader"
        class="pa-2 fill-height"
        tile
        outlined
        style="height: auto"
      >
        <div class="d-flex">
          <div class="history-tl-container">
            <ul class="tl">
              <div
                v-for="(item, index) in trackingDetails.events.event_history"
                :key="index"
                :class="{
                  height:
                    index === trackingDetails.events.event_history.length - 1,
                }"
              >
                <li
                  class="tl-item"
                  ng-repeat="item in retailer_history"
                  v-if="showHistory(item)"
                >
                  <div class="d-flex">
                    <div class="timestamp">
                      <span v-if="item.on">
                        {{ item.on | moment("DD MMM, YYYY hh:mm A") }}
                        <br
                      /></span>

                      <span v-if="item.country_timezone">
                        <span class="text-center">
                          {{ item.country_timezone }}
                        </span>
                        <br />
                      </span>
                      <div class="location">{{ item.location }}</div>
                    </div>
                    <div cols="12" md="12">
                      <div class="item-detail">
                        <span v-if="item.name"
                          >{{ firstLetterCapital(item.name) }}<br
                        /></span>
                        <span class="status" v-if="item.type == 'internal'"
                          >{{
                            item.type == "internal" ? "Internal Status" : ""
                          }}
                          <br
                        /></span>
                        <span v-if="item.response_status_detail">
                          {{ firstLetterCapital(item.response_status_detail)
                          }}<br
                        /></span>
                        <span v-if="item.sub_status">
                          {{ firstLetterCapital(item.sub_status) }}<br
                        /></span>
                        <span v-if="item.comments">
                          {{ firstLetterCapital(item.comments) }}
                        </span>
                      </div>
                      <div class="item-detail" v-if="item.pod_details">
                        <b>Collected By: {{ item.pod_details }} </b>
                      </div>
                    </div>
                  </div>
                </li>
              </div>
            </ul>
          </div>
          <div
            class="item-detail mt-4"
            @click="dialog = true"
            v-if="trackingDetails.events.pod_doc == true"
          >
            <v-icon>mdi-file-document-alert</v-icon>
          </div>
        </div>
      </v-card>
    </v-col>
    <v-dialog v-model="dialog" width="600px">
      <v-card>
        <podData :list="podList" @close="close" />
      </v-card>
    </v-dialog>
    <v-row justify="center">
      <v-dialog v-model="rowDialog" width="800">
        <v-card>
          <v-card-title>
            <v-row>
              <v-col cols="10">
                <span class="text-h5">Carrier Details</span>
              </v-col>
              <v-icon @click="copyTextToClipboard(rowData)"
                >mdi-content-copy</v-icon
              >
              <v-btn
                color="primary"
                class="ml-2 mt-2"
                @click="rowDialog = false"
                >Close</v-btn
              >
              <!-- <v-col cols="1">
                <v-icon @click="rowDialog = false">mdi-close</v-icon>
              </v-col> -->
            </v-row>
          </v-card-title>
          <v-card-text>
            <v-row class="pl-5">
              {

              <template v-for="(value, key) in rowData">
                <v-col cols="12" v-if="Array.isArray(value)" :key="key">
                  <strong>{{ key }}:</strong>
                  <li
                    v-for="(item, index) in value"
                    :key="index"
                    style="list-style-type: none"
                  >
                    {
                    <div v-for="(itemvalue, itemKey) in item" :key="itemKey">
                      <strong>{{ itemKey }}:</strong> {{ itemvalue }}
                    </div>
                    }
                  </li>
                </v-col>
                <v-col class="p-0" cols="12" v-else :key="value"
                  ><strong>{{ key }}:</strong> {{ value }}
                </v-col>
              </template>
              }
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-row>
  </v-row>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import podData from "@/components/front/pod-data";

export default {
  components: {
    podData,
  },
  data: () => ({
    syncLoader: false,
    rowDialog: false,
    rowData: null,
    dialog: false,
    benched: 0,
    trackNo: null,
    trackingDetails: {},
    loader: false,
    trackingID: null,
    trackingItems: [],
    headers: [
      { text: "Item Description", value: "name" },
      { text: "Diamanstion (in cm)", value: "name" },
      { text: "Qty", value: "dateRange" },
    ],
    selectedClient: null,
    refNo: null,
    clientsLoader: false,
    clients: [],
    podList: [],
    orderNo: null,
    orderRef: null,
    message_text: null,
    dialogMessage: false,
  }),
  computed: {
    ...mapGetters(["selectedTrackNo", "userCategory"]),
    isDisabled() {
      if (this.trackingID) {
        return false;
      } else {
        if (this.selectedClient && this.refNo) {
          return false;
        } else {
          return true;
        }
      }
    },
  },

  async created() {
    this.trackNo = this.selectedTrackNo[0];
    if (this.trackNo == undefined) {
      if (this.$route.params.viewName == "orderList") {
        this.trackNo = this.$route.params.id;
      }
      if (this.$route.query.id) {
        this.trackNo = this.$route.query.id;
      }
    }
    await this.fetchDetails(this.trackNo);
  },
  methods: {
    ...mapActions([
      "getTrackingDetails",
      "getPODDetails",
      "getRowData",
      "snackBar",
      "syncTrackingDetails",
      "statusDisplay",
      "downloadSingleInvoiceApi",
      "downloadPackageDetails",
      "runTempSummary",
      "retriggerSlaOrder",
    ]),
    download(id) {
      this.packagesLoader = true;
      this.downloadPackageDetails(id)
        .then((res) => {
          this.fileDownload(res);
          this.packagesLoader = false;
        })
        .catch(() => {
          this.packagesLoader = false;
        });
    },
    syncData() {
      this.syncLoader = true;
      let payload = {
        order_id: this.trackingDetails.events.order.id,
        carrier_code: this.trackingDetails.events.order.carrier_code,
      };

      this.syncTrackingDetails(payload)
        .then((res) => {
          this.syncLoader = false;

          this.snackBar({
            color: "success",
            message: res.data.message,
          });

          this.fetchDetails(this.trackNo);
        })
        .catch(() => {
          this.syncLoader = false;
        });
    },
    async copyTextToClipboard() {
      let text = JSON.stringify(this.rowData);
      await navigator.clipboard.writeText(text);
      this.snackBar({
        color: "success",
        message: "Text copied to clipboard",
      });
    },
    downloadSingleInvoice(id) {
      this.packagesLoader = true;
      let payload = { tracking_no: id };
      this.downloadSingleInvoiceApi(payload)
        .then((res) => {
          this.fileDownload(res);
          this.packagesLoader = false;
        })
        .catch(() => {
          this.packagesLoader = false;
        });
    },
    async showRowData() {
      await this.getRowData(this.orderNo).then((res) => {
        this.rowData = res.data.response_body;
        this.rowDialog = true;
      });
    },
    showHistory(item) {
      if (this.userCategory.user_category === 1) {
        if (item.type == "internal") {
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }
    },
    async fetchDetails(trackNo) {
      this.loader = true;
      await this.getTrackingDetails({
        tracking_no: trackNo,
      })
        .then((res) => {
          this.loader = false;
          this.trackingDetails = res.data;
          this.trackingItems = this.trackingDetails.events.package;
          this.orderNo = res.data.events.order.id;
          if (this.trackingDetails.events.pod_doc == true) {
            this.getPODDetails(this.orderNo).then((res) => {
              this.podList = res.data.pod_data;
            });
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    close() {
      this.dialog = false;
    },
    checkAndAdd(index, nos) {
      if (
        10 > nos.length &&
        index + 1 === nos.length &&
        nos.filter((item, i) => i !== index && !item).length === 0
      ) {
        nos.push(null);
      }
    },
    run(item) {
      this.runTempSummary(item.events.order.id).then((res) => {
        this.snackBar({
          color: "success",
          message: res.data[0],
        });
      });
    },
    retrigger(item) {
      let payload = {
        order_id: item.events.order.id,
      };
      this.retriggerSlaOrder(payload).then((res) => {
        this.snackBar({
          color: "success",
          message: res.data.message,
        });
      });
    },
  },
};
</script>
<style scoped>
.clearfix:after {
  clear: both;
  content: "";
  display: block;
  height: 0;
}
.arrow-steps {
  display: inline-flex;
}
.arrow-steps .step {
  font-size: 14px;
  text-align: center;
  color: #666;
  cursor: default;
  margin: 0 3px;
  padding: 10px;
  min-width: 40px;
  float: left;
  position: relative;
  background-color: #d9e3f7;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  transition: background-color 0.2s ease;
}

.arrow-steps .step:after,
.arrow-steps .step:before {
  content: " ";
  position: absolute;
  top: 0;
  right: -17px;
  width: 0;
  height: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  border-left: 17px solid #d9e3f7;
  z-index: 2;
  transition: border-color 0.2s ease;
}

.arrow-steps .step:before {
  right: auto;
  left: 0;
  border-left: 17px solid #fff;
  z-index: 0;
}

.arrow-steps .step:first-child:before {
  border: none;
}

.arrow-steps .step:last-child:after {
  border: none;
}

.arrow-steps .step:first-child {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}

.arrow-steps .step:last-child {
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}

.arrow-steps .step.current {
  color: #fff;
  background-color: #23468c;
}

.arrow-steps .step.current:after {
  border-left: 17px solid #23468c;
}

.v-list--two-line .v-list-item,
.v-list-item--two-line {
  min-height: auto;
}
strong {
  padding-right: 30px;
}
.v-timeline-item__divider {
  padding-right: 28px;
}
.v-timeline-item__body {
  padding-bottom: 17px;
}
.custom-timeline .v-timeline-item__dot .v-timeline-item__inner-dot {
  height: 12px !important;
  width: 12px !important;
}

.custom-timeline .v-timeline-item__dot {
  z-index: 2;
  border-radius: 50%;
  box-shadow: 0px 2px 1px -1px rgba(0, 0, 0, 0.2),
    0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);
  height: 12px !important;
  left: calc(50% - 19px);
  width: 12px !important;
}
.v-timeline
  cutom-timeline
  v-timeline--align-top
  v-timeline--dense
  theme--light::before {
  left: 13px !important;
  right: 25px !important;
  top: auto !important;
}
.custom-timeline .wrap {
  padding-left: 5px;
  padding-left: 0px;
}
.v-application--is-ltr .v-timeline--dense:not(.v-timeline--reverse):before {
  left: 9px !important;
  right: 25px !important;
  top: auto !important;
}
body {
  line-height: 1.3em;
  min-width: 920px;
}

/* .history-tl-container ul.tl li:hover::before {
  border-color: #258cc7;
  transition: all 1000ms ease-in-out;
} */
ul.tl li .item-title {
}
ul.tl li .item-detail {
  color: rgba(0, 0, 0, 0.5);
  font-size: 12px;
}
ul.tl li .timestamp {
  color: #8d8d8d;
  margin-left: -156px;
  text-align: left;
  font-size: 12px;
}
table {
  border-collapse: collapse;
  width: 100%;
}

th,
td {
  text-align: left;
  border-bottom: 1px solid #ddd;
  font-size: 0.875rem;
  padding-left: 15px;
  height: 48px;
}

th {
  color: gray;
  font-size: 12px;
}
.br-0 {
  border-radius: 0px !important;
}
.tracking {
  color: #23468c;
  margin-bottom: 16px;
  font-size: 14px;
  font-weight: 500;
}
.card {
  box-shadow: none;
}
.v-application .elevations {
  box-shadow: 0px 2px 1px -1px rgba(0, 0, 0, 0),
    0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12) !important;
}
.top {
  top: -12px;
}
.top-6 {
  top: -6px;
}
.status {
  background-color: lightskyblue;
  font-weight: bold;
  color: black;
  padding: 3px;
  border-radius: 5px;
}
.p-0 {
  padding: 0;
}
.location {
  width: 150px;
  line-height: 12px;
}
.prealert .col-2 {
  flex: 0 0 14.2666666667% !important;
  max-width: 14.2666666667% !important;
}

/* Target the v-card inside the tooltip */
.custom-tooltip {
  background-color: white !important;
  box-shadow: none !important;
  border: none !important;
}
</style>
